<nav class="side-nav-padding navbar fixed-top navbar-expand-md navbar-dark scrolling-navbar double-nav side-nav-open-topnav" style="background-color: rgb(44, 47, 52); display: flex;">
    <h4 class="white-text breadcrumb-dn" id="pageHeading" style="margin-left:5px">{{title}}</h4>
    <ul class="nav navbar-nav nav-flex-icons ml-auto">
        <li class="nav-item nav-item-important">
            <a (click)="onClickContact()" class="nav-link waves-effect waves-light"><i class="fas fa-envelope"></i> <span class="clearfix d-none d-sm-inline-block">Support</span></a>
        </li>
        <li class="nav-item">
            <a (click)="onClickNew()" class="nav-link pink-text waves-effect waves-light"><i class="fas fa-bell pink-text"></i> <span class="clearfix d-none d-sm-inline-block">New</span></a>
        </li>
    </ul>
</nav>